

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        betriebe: {
            list: [/*{"AGIS":10109046,"BTRDTANAME1":null,"ID":10233}*/],
            expired: 0 /* 1h wird alles cached */
        }
    },
    actions: { // kommt vom Profil 
        },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setBetriebe: function (state, betriebe) {
            state.betriebe.list = betriebe
            state.betriebe.expired = Date.now()+60*60*1000
        },
        

    }
}